<div class="modal-header">
  <h2 mat-dialog-title>No Internet Connection</h2>
  <button type="button" class="close-button" mat-dialog-close aria-label="Close modal"><span class="ion-android-close" area-hidden="true"></span></button>
</div>
<mat-dialog-content>
  <div class="oneSetting">
    <h4 class="warningNoInt">Warning:</h4>
    <p>Your current work is not being saved.<br>
      Please check your connectivity or contact your network administrator and try again.</p>
  </div>
</mat-dialog-content>
